import React from 'react';
import { sharedSpacesData, heroImages } from '../../data/mock';
import { Check } from 'lucide-react';

const SharedSpaces = () => {
  return (
    <section id="shared-spaces" className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1 relative">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src={heroImages.poolside}
                alt="Shared spaces"
                className="w-full h-[400px] object-cover"
              />
            </div>
            <div className="absolute -z-10 -bottom-4 -left-4 w-full h-full bg-[#5C7A6E]/15 rounded-2xl" />
          </div>

          <div className="order-1 lg:order-2">
            <h2 className="font-display text-3xl md:text-4xl font-normal text-[#1E2E2A] mb-8 tracking-wider">
              {sharedSpacesData.title}
            </h2>
            
            <p className="text-lg text-[#1E2E2A]/70 leading-relaxed mb-10">
              {sharedSpacesData.intro}
            </p>

            <ul className="space-y-4 mb-8">
              {sharedSpacesData.bullets.map((item, index) => (
                <li key={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-6 h-6 rounded-md bg-[#3E6259]/10 flex items-center justify-center mt-0.5">
                    <Check className="w-4 h-4 text-[#3E6259]" />
                  </div>
                  <span className="text-[#1E2E2A] text-lg">
                    {item}
                  </span>
                </li>
              ))}
            </ul>

            <p className="text-sm text-[#5C7A6E]">
              {sharedSpacesData.closingLine}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SharedSpaces;
